import { setCharacter, setGlobalQuestions, TCharacter } from "../../store/slices/gameObjectSlice";
import { store } from "../../store/store";
import Character from "../Character";
import Question from "../Questions";
import * as funcs from "../../components/functions";
import Game from "../Game";
import { Action } from "../Actions/Action";
import { jump } from "../jump";

// Declare the type definition for the window object
declare var window: Window & typeof globalThis;

// Declare the function in the global scope
declare global {
    function updateVar(variable: string, value: any): void;
    function updateCharacter(characterName: string, property: string, value: any): void;
    function updateCharacterName(characterName: string, name: string): void;
    function getVars(): void;
    function getVar(value: any): void;
    function getCharacter(characterName: string): void;
    function getAllScenes(): void;
    function getSeenScenes(): void;
    function jumpToScene(scene: string): void;
}

// Define the function implementation as a property on the window object
window.updateVar = function (variable: string, value: any) {
    Game.rollback = 1;
    store.dispatch(setGlobalQuestions({ ...Question.globalAnswers, [variable]: value }));
};
window.getVar = function (value: any) {
    console.log(Question.globalAnswers[value as keyof typeof Question.globalAnswers]);
};
window.getVars = function () {
    console.log(Question.globalAnswers);
};
window.updateCharacter = function (characterKey: string, property: string, value: any) {
    const char = store.getState().gameObject.present.characters[characterKey] as TCharacter;
    if (!char) {
        console.error(`no such char`);

    }
    store.dispatch(setCharacter({ ...char, properties: { ...char.properties, [property]: value } }));
};
window.updateCharacterName = function (characterKey: string, name: string) {
    const char = store.getState().gameObject.present.characters[characterKey] as TCharacter;
    if (!char) {
        console.error(`no such char`);

    }
    store.dispatch(setCharacter({ ...char, name }));
};
window.getCharacter = function (characterKey: string,) {
    const char = store.getState().gameObject.present.characters[characterKey] as TCharacter;
    console.log(char);
};
window.getAllScenes = function () {
    const scenes = [];
    let counter = 0;
    for (const f in funcs) {
        if (counter > 2) {
            scenes.push(f);
        }

        counter++;

    }
    console.log(scenes);
    return scenes;

};
window.getSeenScenes = function () {
    return store.getState().gameObject.present.seenScenarios;

};
window.jumpToScene = function (scene: string,) {
    // Game.rollback = 1;
    Action.head = null;
    Game.Action = null;
    jump(((funcs as any)[scene]), scene);
    // ((funcs as any)[scene])();
};

export { };